import React, { Component } from 'react';
import Cookies from 'js-cookie';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import { LookupCursadasAlumnos } from '../Cursadas/LookupCursadasAlumnos';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { SELECT_LABELS, selectPlaceholder } from '../../services/selectOptions';
import { InscripcionExamenErrorMessage } from '../InscripcionExamen/InscripcionExamenErrorMessage';

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddInscripcionCursadaAlumnos extends Component {
  static displayName = AddInscripcionCursadaAlumnos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingInitial: true,
      loadError: '',
      errorMessage: '',
      redirect: false,
      showCursada: false,
      tagDataAlumno: [],
      tagDataCursada: [{ id: '', text: '', materiaCarreraCod3: '' }],
      alumno: 0,
      carreraCursada: -1,
      ignorarCorrelatividad: false,
      valueCarrera: selectPlaceholder('Seleccione la Carrera'),
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  async componentDidMount() {
    const canAccess = constantClass.canAccess('InscribirCursada');
    if (canAccess) {
      await this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleChangeAlumno = (option) => {
    if (!option || !option.value) {
      return;
    }
    const carreraProperties = option.value.toString().split('-');
    this.clearFeedback();
    this.setState({
      valueCarrera: option,
      alumno: parseInt(carreraProperties[1], 10),
      carreraCursada: parseInt(carreraProperties[0], 10),
      tagDataCursada: [{ id: '', text: '', materiaCarreraCod3: '' }],
    });
  };

  handleShowCursadaLookup = () => {
    if (!this.state.loading && this.state.carreraCursada !== -1) {
      this.setState({ showCursada: true });
    }
  };

  handleHideLookup1 = () => {
    this.setState({ showCursada: false });
  };

  handleSelectCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    const tag = {
      id: carreraProperties[0],
      text: carreraProperties[1].trim() + ' - ' + carreraProperties[2].trim() + ' - ' + carreraProperties[4].trim(),
      materiaCarreraCod3: carreraProperties[5].trim(),
    };
    const tagData = this.state.tagDataCursada;
    const existe = tagData.filter((x) => x.id === carreraProperties[0]);
    if (existe.length === 0) {
      tagData.push(tag);
      this.clearFeedback();
      this.setState({
        showCursada: false,
        tagDataCursada: tagData,
      });
    } else {
      this.setState({ showCursada: false });
    }
  };

  handleDeleteCursada = (id) => {
    this.clearFeedback();
    this.setState({
      tagDataCursada: this.state.tagDataCursada.filter((tag) => tag.id !== id),
    });
  };

  isFormValid() {
    const tags = this.state.tagDataCursada.slice(1);
    return tags.length > 0 && this.state.alumno !== 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios.' });
      return;
    }
    this.saveStudent();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch(
      'api/axc/inscripcion/' + JSON.parse(Cookies.get('alumnoCodigos')),
      { method: 'GET' }
    );

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar las carreras del alumno.'
        ),
      });
      return;
    }

    const options = [];
    data.returnModel.sort((a, b) => a.carreraCod - b.carreraCod);
    for (let i = 0; i < data.returnModel.length; i += 1) {
      options.push({
        value: data.returnModel[i].carreraCod + ' - ' + data.returnModel[i].alumnoxCarreraCod,
        label: data.returnModel[i].carreraNombre,
      });
    }

    this.setState({
      loadingInitial: false,
      tagDataAlumno: options,
    });
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const object = [];
    this.state.tagDataCursada.slice(1).forEach((tag) => {
      object.push({ Cursada: parseInt(tag.id, 10), MateriaCarreraCod3: tag.materiaCarreraCod3 });
    });

    const { data } = await constantClass.apiFetch('api/ic/multiple', {
      method: 'POST',
      body: JSON.stringify({
        AlumnoxCarreraCod: this.state.alumno,
        IgnorarCorrelatividad: this.state.ignorarCorrelatividad,
        Cursadas: object,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudieron guardar las inscripciones. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  renderCursadaTags() {
    const tagData = this.state.tagDataCursada.slice(1);
    if (tagData.length === 0) {
      return <p className="md-form-page__empty-hint">Ninguna cursada seleccionada</p>;
    }
    return (
      <ul className="md-form-page__tags md-form-page__tags--stack">
        {tagData.map((tag) => (
          <li key={tag.id} className="md-form-page__tag md-form-page__tag--stacked md-form-page__tag--inline">
            <span className="md-form-page__tag-label">{tag.text}</span>
            <button
              type="button"
              className="md-form-page__tag-remove"
              onClick={() => this.handleDeleteCursada(tag.id)}
              disabled={this.state.loading}
              aria-label={'Quitar ' + tag.text}
            >
              ×
            </button>
          </li>
        ))}
      </ul>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-ica" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      tagDataAlumno,
      carreraCursada,
      showCursada,
      alumno,
      valueCarrera,
    } = this.state;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-ica">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">Nueva Inscripción a Cursada</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-ica">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">Nueva Inscripción a Cursada</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-ica">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nueva Inscripción a Cursada</h1>
        <p className="md-form-page__subtitle">
          Seleccione la carrera y una o más cursadas para inscribirse.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <InscripcionExamenErrorMessage message={errorMessage} /> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando inscripciones, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Carrera</span>
              <div className="md-form-page__select-wrap">
                <Select
                  inputId="ica-carrera"
                  classNamePrefix="md-form-page__select"
                  classNames={SELECT_CLASS_NAMES}
                  placeholder={SELECT_LABELS.opcion}
                  options={tagDataAlumno}
                  value={valueCarrera}
                  onChange={this.handleChangeAlumno}
                  isDisabled={loading}
                />
              </div>
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Cursadas</span>
              {carreraCursada !== -1 ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCursadaLookup}
                  disabled={loading}
                >
                  Seleccione la Cursada
                </button>
              ) : (
                <p className="md-form-page__empty-hint">Seleccione la Carrera para poder elegir Cursadas.</p>
              )}
              {showCursada ? (
                <LookupCursadasAlumnos
                  alumnoCarreraCod={alumno}
                  carreraCod={carreraCursada}
                  selectItem={this.handleSelectCursadaItem}
                  hideLookup={this.handleHideLookup1}
                />
              ) : null}
              {this.renderCursadaTags()}
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={loading}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
